import React from "react";
import { Mobile } from "@govlaunch/core";

export default function GovlaunchProject({ attributes, element, children }) {
  const { slug, countryCode, title } = element;

  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div contentEditable={false}>
        <Mobile>
          {(isMobile) => {
            return (
              <div
                css={{
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  css={{
                    padding: isMobile ? 8 : 16,
                    border: "1px solid #BDDAFD",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <a
                    href={`/projects/${slug}`}
                    css={{
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    {countryCode && (
                      <img
                        src={`https://static.govlaunch.com/flags/squared/${countryCode}.svg`}
                        alt={`${countryCode} flag`}
                        width={64}
                        height={48}
                        css={{
                          width: 64,
                          height: 48,
                          marginRight: isMobile ? 12 : 24,
                          aspectRatio: "4 / 3",
                          alignSelf: "flex-start",
                        }}
                      />
                    )}

                    <p
                      css={{
                        margin: 0,
                        color: "#086BE5",
                        fontWeight: "bold",
                        fontSize: isMobile ? 14 : 18,
                        lineHeight: "24px",
                      }}
                    >
                      {title}
                    </p>
                  </a>
                </div>
              </div>
            );
          }}
        </Mobile>
      </div>
    </div>
  );
}
